import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonToast from "../../../_utils/CommonToast";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../_utils/IfscLogoMapper";
import TickerAnimation from "../../../_utils/TickerAnimation";
import { useSelector } from "react-redux";

const BeneficiaryAccountGridView = ({
  id,
  data,
  type,
  typepop,
  handleButtonClick,
  associateAccount,
  setOpenBeneAssociate,
  txnPayLoad,
  associateTxn,
  scheduleIntenralTxn,
  isLabelClicked,
  LabelAccounts,
  setlableInput,
  filterRef,
  subType,
  beneAccountId,
  onCardNavigate,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow,
  handleLabelSelect,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { services } = useSelector((state) => state.refreshToken);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  return (
    <>
      <div
        style={{
          zIndex: typepop === "popup" && "var(--z-index-content)",
        }}
        className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md
    ${
      data?.filter((item) => item.id !== beneAccountId).length ===
        GlobalConfiguration.lengthCheckZero && "flex-1"
    }`}
      >
        {data?.length > GlobalConfiguration.lengthCheckZero &&
          data?.map((account, index) => {
            const redirectUrl = `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${account.id}`;
            return (
              <CardContainer
                key={account.id}
                hoverHeight={GlobalConfiguration.beneAccountCardHoverHeight}
                filterRef={filterRef}
                minHeight={GlobalConfiguration.BeneAccCardMinHeight}
                context={account}
                isSelected={
                  Array.isArray(LabelAccounts) &&
                  LabelAccounts?.some((item) => item?.id === account.id)
                }
                isDisabled={
                  account.id === id ||
                  account.id === beneAccountId ||
                  (!(
                    associateAccount ||
                    (associateTxn === "associateTxn" &&
                      (account?.approval_status === "blocked" ||
                        account?.approval_status === "archived" ||
                        account?.approval_status === "rejected"))
                  ) &&
                    typepop === "popup" &&
                    (account?.approval_status === "blocked" ||
                      account?.approval_status === "archived" ||
                      account?.approval_status === "rejected"))
                }
                onClickHandler={(e) => {
                  if (classifiedFlow) {
                    navigate(
                      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${account.id}`,
                      {
                        replace: true,
                      },
                    );
                    return;
                  }
                  if (
                    type === "activeInactive" ||
                    type === "confirm_create_account"
                  ) {
                    setIsalertPopup(true);
                    setFlowSelectedId(account?.id);
                    return;
                  }
                  if (associateAccount && subType === "reimbursement") return;
                  if (onCardNavigate) {
                    onCardNavigate(redirectUrl);
                    return;
                  }
                  if (
                    typepop === "popup" &&
                    scheduleIntenralTxn &&
                    (account?.approval_status === "blocked" ||
                      account?.approval_status === "archived" ||
                      account?.approval_status === "rejected" ||
                      (txnPayLoad?.ownerBankAccountNo ===
                        account?.bank_acc_no &&
                        txnPayLoad?.ownerBankIFSC === account?.ifsc_code &&
                        txnPayLoad?.ownerPan === account?.pan_no))
                  ) {
                    CommonToast({
                      text: "Destination account cannot be same as source account.",
                      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                      variant: "var(--error)",
                      buttonNeeded: false,
                    });
                    return;
                  } else if (
                    typepop === "popup" &&
                    (account?.approval_status === "blocked" ||
                      account?.approval_status === "archived" ||
                      account?.approval_status === "rejected") &&
                    !associateAccount
                  ) {
                    if (isLabelClicked) {
                      handleLabelSelect?.(account);
                      setlableInput(false);
                    } else {
                      return;
                    }
                  } else if (typepop === "popup" && !associateAccount) {
                    if (isLabelClicked) {
                      handleLabelSelect?.(account);
                      setlableInput(false);
                    } else {
                      if (e && e.stopPropagation) {
                        e.stopPropagation();
                      }
                      handleButtonClick(account);
                    }
                  } else {
                    const redirectUrl = `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${account.id}`;
                    if (!isLabelClicked) {
                      if (type !== "viewOnlyCards") {
                        if (onCardNavigate) {
                          onCardNavigate(redirectUrl);
                          return;
                        } else {
                          navigate(redirectUrl, {
                            state: {
                              isViewAll:
                                location.pathname ===
                                "/beneficiary_account_dashboard/beneficiary_account_view_all",
                            },
                          });
                        }
                      }
                      if (setOpenBeneAssociate) setOpenBeneAssociate(false);
                      setlableInput(false);
                    } else {
                      handleLabelSelect?.(account);
                      setlableInput(false);
                    }
                  }
                }}
              >
                <card-body>
                  <TextWithIcon
                    type={"text"}
                    text={account.name}
                    textColor={"var(--text-primary)"}
                    subText={"Account name"}
                    iconComponentArray={[
                      ...(isLabelClicked
                        ? [
                            {
                              icon:
                                Array.isArray(LabelAccounts) &&
                                LabelAccounts?.some(
                                  (item) => item?.id === account.id,
                                )
                                  ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                  : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                              isDisabled: false,
                            },
                          ]
                        : []),
                    ]}
                  />

                  <div className="flex gap-x-gap-sm justify-between items-center">
                    <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                      <p className="text-font-sm text-text-primary flex-1 truncate font-normal px-mobile-padding-l Qmd:px-padding-sm">
                        <TickerAnimation
                          text={formatAccountNumber(account.bank_acc_no)}
                        />
                      </p>

                      <div className="w-full relative flex px-mobile-padding-l Qmd:px-padding-sm justify-between items-center">
                        <p className="text-font-xs text-text-secondary flex-1 truncate font-normal">
                          Account number
                        </p>
                      </div>
                    </div>

                    <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                      <div className="Qsmd:w-banklogo-width-sm Qsmd:h-banklogo-height-sm w-banklogo-width-mobile h-banklogo-height-mobile flex-shrink-0">
                        <IfscCodeMapper ifscCode={account?.ifsc_code} />
                      </div>
                    </div>
                  </div>

                  <TextWithIcon
                    text={
                      (services?.includes("BAAccount") ||
                        services?.includes("Admin")) &&
                      account?.approval_status === "pending"
                        ? "Require approval"
                        : account?.approval_status
                    }
                    subText={"Account status"}
                    textCase={"capitalize"}
                    fontWeight={"semibold"}
                    textColor={getStatusColor(account?.approval_status)}
                  />
                </card-body>

                <card-hover>
                  <TextWithIcon
                    text={account?.labels?.join(", ") || "No labels assigned"}
                    iconComponentArray={[{ icon: ICONS?.LABEL }]}
                    fontWeight={"normal"}
                    textColor={"var(--text-primary)"}
                  />
                </card-hover>
              </CardContainer>
            );
          })}
      </div>
    </>
  );
};

export default BeneficiaryAccountGridView;
